(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kits-comparison"] && !window.DesignMode) return;
  try {
    
$(function(){
  $('.dropdown-wrap').on('click', function(){
    $(this).toggleClass('active');
    $('#dropdown-'+$(this).attr('target')).slideToggle();
    var btn = $(this).find(".hc-btn");
    $(btn).toggleClass('flip');
  });

  $('.kits-comparison .reviews-wrap .yotpo').on("click", function(e) {
    e.preventDefault();
    $('#yotpo-testimonials').toggleClass('yotpo-modal-active');
    $('#yotpo-testimonials').css('display', 'block');
    console.log("reviews clicked");
  });
});

  } catch(e) { console.error(e); }
})();
})();
